import { Divider, Drawer, FormControl, Grid, IconButton, Input, InputLabel, ListItemText, MenuItem, Select, Typography, Button, Box, Chip, Badge, CircularProgress, LinearProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import { getDatosFiltros } from '../../services/apis';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const FiltrosCuadrillas = ({ open, setOpen, cuadrillas, setCuadrillas, cuadrillasOG, setCantidadFiltros, cantidadFiltros }) => {

    const [arrFiltros, setArrFiltros] = useState([])

    // Función para contar y actualizar la cantidad de filtros aplicados
    const actualizarCantidadFiltros = () => {
        let totalFiltros = 0;

        arrFiltros.forEach(filtro => {
            totalFiltros += filtro.seleccionado.length;
        });

        setCantidadFiltros(totalFiltros);
        return totalFiltros;
    }

    useEffect(() => {
        if (cuadrillasOG) {
            aplicarFiltros();
        }
    }, [arrFiltros, cuadrillasOG]); // Se ejecuta cuando arrFiltros cambia

    // Modifica handleChange para que NO llame a aplicarFiltros:
    const handleChange = (index) => (event) => {
        const {
            target: { value },
        } = event;

        const nuevosValores = typeof value === 'string' ? value.split(',') : value;

        setArrFiltros(prev => {
            const nuevosFiltros = [...prev];
            nuevosFiltros[index] = {
                ...nuevosFiltros[index],
                seleccionado: nuevosValores
            };
            return nuevosFiltros;
        });
        // NO llamar aplicarFiltros aquí
    };

    // Función para cargar datos de la API
    const cargarDatosFiltros = async () => {
        try {
            const response = await getDatosFiltros();

            console.log(response);

            if (response.success) {
                setArrFiltros(response.data);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    // Función para obtener los filtros seleccionados en un formato útil
    const obtenerFiltrosAplicados = () => {
        const filtros = {};
        arrFiltros.forEach(filtro => {
            if (filtro.seleccionado.length > 0) {
                filtros[filtro.key] = filtro.seleccionado;
            }
        });
        return filtros;
    }

    const pasaFiltro = (cuadrilla, tipoFiltro, valores) => {
        switch (tipoFiltro) {
            case 'empresas':
                return valores.includes(cuadrilla.datos_cuadrilla.nombre_cliente);

            case 'personas':
                // Verificar cabo
                if (valores.includes(cuadrilla.datos_cuadrilla.nombre_cabo)) {
                    return true;
                }

                // Verificar todos los recolectores
                const todosRecolectores = [
                    ...cuadrilla.recolectores.no_comprobados,
                    ...cuadrilla.recolectores.comprobados,
                    ...cuadrilla.recolectores.error_comprobacion
                ];

                return todosRecolectores.some(recolector =>
                    valores.includes(recolector.nombre_recolector)
                );

            case 'validado':
                const validadoStr = cuadrilla.datos_cuadrilla.validado === 1 ? 'Si' : 'No';
                return valores.includes(validadoStr);

            case 'revisado':
                const revisadoStr = cuadrilla.datos_cuadrilla.revisado === 1 ? 'Si' : 'No';
                return valores.includes(revisadoStr);

            default:
                return true; // Para filtros no reconocidos, no filtrar
        }
    };

    // Función para aplicar los filtros
    const aplicarFiltros = () => {
        const filtrosAplicados = obtenerFiltrosAplicados();
        console.log('Filtros aplicados:', filtrosAplicados);

        // Si no hay filtros, mostrar todas
        if (Object.keys(filtrosAplicados).length === 0) {
            setCuadrillas(cuadrillasOG);
            // setOpen(false);
            return;
        }

        // Aplicar filtro
        const cuadrillasFiltradas = cuadrillasOG.filter(cuadrilla => {
            // La cuadrilla debe pasar TODOS los filtros aplicados
            return Object.entries(filtrosAplicados).every(([tipoFiltro, valores]) =>
                pasaFiltro(cuadrilla, tipoFiltro, valores)
            );
        });

        console.log(`Resultado: ${cuadrillasFiltradas.length} cuadrillas encontradas`);

        setCuadrillas(cuadrillasFiltradas);
        // setOpen(false);
    };

    // Función para limpiar todos los filtros
    const limpiarFiltros = () => {
        setArrFiltros(prev => prev.map(filtro => ({
            ...filtro,
            seleccionado: []
        })));
        setCuadrillas(cuadrillasOG);
    }

    const borrarFiltro = (filtroKey, info) => {
        setArrFiltros(prev => {
            const nuevosFiltros = [...prev];
            const filtroIndex = nuevosFiltros.findIndex(f => f.key === filtroKey);
            if (filtroIndex !== -1) {
                nuevosFiltros[filtroIndex] = {
                    ...nuevosFiltros[filtroIndex],
                    seleccionado: nuevosFiltros[filtroIndex].seleccionado.filter(item => item !== info)
                };
            }
            return nuevosFiltros;
        });

        aplicarFiltros();
    }

    useEffect(() => {
        cargarDatosFiltros();
    }, [])

    useEffect(() => {
        actualizarCantidadFiltros()
    }, [arrFiltros])


    return (
        <Drawer
            open={open}
            onClose={() => setOpen(false)}
            anchor={'right'}
            PaperProps={{
                sx: {
                    width: {
                        xs: '80%',
                        sm: '45%',
                        md: '30%',
                        lg: '25%',
                        xl: '20%'
                    },
                },
            }}
        >

            <Grid
                container
                direction="column"
                justifyContent="space-between"
                alignItems="center"
                size={{ xs: 12 }}
                sx={{ p: 1.5, height: '100%' }}
            >
                <Grid container direction="column" size={{ xs: 12 }}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        size={{ xs: 12 }}
                    >
                        <Typography variant='h5'>
                            Filtros
                        </Typography>

                        <IconButton onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>

                    <Divider sx={{ my: 1 }} />

                    <Grid
                        container
                        direction="column"
                        justifyContent="start"
                        alignItems="center"
                        size={{ xs: 12 }}
                        spacing={2}
                    >
                        {arrFiltros.map((filtro, index) => (
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                size={{ xs: 12 }}
                            >
                                <FormControl key={filtro.key} variant='standard' fullWidth >
                                    <InputLabel id={`label-${filtro.key}`}>{filtro.nombre}</InputLabel>
                                    <Select
                                        labelId={`label-${filtro.key}`}
                                        id={`select-${filtro.key}`}
                                        multiple
                                        value={filtro.seleccionado}
                                        onChange={handleChange(index)}
                                        input={<Input label={filtro.nombre} />}
                                        renderValue={(selected) => selected.length > 0 ? selected.join(', ') : `Seleccionar ${filtro.nombre}`}
                                        MenuProps={MenuProps}
                                    >
                                        {filtro.valores.length > 0 ? (
                                            filtro.valores.map((valor) => (
                                                <MenuItem key={valor.nombre} value={valor.nombre}>
                                                    <Checkbox checked={filtro.seleccionado.includes(valor.nombre)} />
                                                    <ListItemText primary={valor.nombre} />
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <MenuItem disabled>
                                                <LinearProgress />
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="start"
                                    alignItems="start"
                                    size={{ xs: 12 }}
                                >
                                    {filtro.seleccionado.map((info, index) => (
                                        <Chip label={info} variant="filled" onDelete={() => borrarFiltro(filtro.key, info)} color='secondary' />
                                    ))}
                                </Grid>
                            </Grid>

                        ))}
                    </Grid>
                </Grid>

                {/* Botones de acción */}
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12 }}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={limpiarFiltros}
                        fullWidth
                    >
                        Limpiar filtros ({cantidadFiltros})
                    </Button>
                </Grid>
            </Grid>

        </Drawer >
    )
}